/**
 * GENERATED by ben/tools/crm-glyphs/build_glyphs.py --react (symbol set v2, decided by Arif 2026-09-09).
 * Do not edit by hand: change the tool, regenerate, commit. The markup is the effect stack the design
 * document (CRM-TILE-SYSTEM-2026-09-08.html) renders inline; every id carries the instance prefix `id`
 * (React useId) because ids are document-wide and `use` would otherwise resolve another glyph's defs.
 */
/** The 15 object symbols (the data objects and the AI assistant): what a picker offers an object. */
export const OBJECT_GLYPH_NAMES = [
  'pulse',
  'call',
  'creator',
  'person',
  'team',
  'agency',
  'lead',
  'deal',
  'enrollment',
  'gameplan',
  'payment',
  'win',
  'phase',
  'delivery',
  'ai',
] as const;

/** The 16 function-row symbols (sidebar rows that are not objects): never offered for an object. */
export const FUNCTION_GLYPH_NAMES = [
  'dashboard',
  'reports',
  'tasks',
  'pending',
  'objects',
  'settings',
  'sidebar',
  'workflows',
  'imports',
  'exports',
  'webhooks',
  'inbound',
  'health',
  'members',
  'identity',
  'instance',
] as const;

/** Every symbol name, and nothing else: validation imports this, rendering imports `index.ts`. */
export const GLYPH_NAMES = [...OBJECT_GLYPH_NAMES, ...FUNCTION_GLYPH_NAMES] as const;

export type GlyphName = (typeof GLYPH_NAMES)[number];

export function isGlyphName(value: string): value is GlyphName {
  return (GLYPH_NAMES as readonly string[]).includes(value);
}
